import { createAction } from 'redux-actions'

import * as constants from './constants'

export const updateInbox = createAction(constants.UPDATE_INBOX)
export const updateInboxSuccess = createAction(constants.UPDATE_INBOX_SUCCESS)
export const updateInboxPending = createAction(constants.UPDATE_INBOX_PENDING)
export const updateInboxFailed = createAction(constants.UPDATE_INBOX_FAILED)
